var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A3365;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.14,4.04C74,3.75,96.11,23.66,96,50.15c-0.11,25.44-20.91,45.83-46.03,45.82C24.9,95.95,4.07,75.56,4,50.07 C3.93,23.54,26.18,3.59,50.14,4.04z M43.27,39.44c0,4.81,0.01,9.61-0.01,14.42c-0.01,1.45,0.27,2.68,1.56,3.61 c5.08,3.64,10.11,7.34,15.19,10.99c1.77,1.28,2.81,1.06,4.14-0.75c1.41-1.91,2.8-3.82,4.2-5.73c1.52-2.08,1.37-3-0.76-4.54 c-2.98-2.16-5.9-4.42-8.98-6.42c-1.56-1.01-1.96-2.19-1.94-3.92c0.07-7.37,0.05-14.74,0.02-22.12c-0.01-2.58-0.62-3.14-3.15-3.16 c-2.24-0.01-4.48-0.01-6.71,0c-2.96,0.01-3.53,0.57-3.54,3.61C43.25,30.1,43.27,34.77,43.27,39.44z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.34058d0b9c5daf9da335e517a3902a1b.svg";
export { ForwardRef as ReactComponent };